<template>
<div class="va-row">
  <div class="flex md12 xs12">
    <vuestic-widget>
      <div class="va-row">
        <div class="flex md6">
          <div class="select-title">{{'basic.select.currency' | translate}}:</div>
          <el-select v-model="currency_value" placeholder="">
            <el-option v-for="(item, index) in currencyList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="flex md6">
          <div class="select-title">{{'basic.select.method' | translate}}:</div>
          <el-select v-model="method_value" :placeholder="$t('common.selectPlaceholder')">
            <el-option :label="$t('basic.select.all')" value="" selected />
            <el-option v-for="(item, index) in methodList" :key="index" :label="item" :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="flex">
        <button class="btn btn-primary btn-micro" @click="drawReports">
          <div class="btn-with-icon-content">
            <i class="fa fa-refresh"></i>
            {{'basic.button.apply' | translate}}
          </div>
        </button>
      </div>
    </vuestic-widget>
  </div>
  <div class="flex md12 xs12" style="width: 100%;">
    <vuestic-widget :headerText="$t('report.daily')">
      <div id="dailyReportChart" ref="dailyReportChart"></div>
    </vuestic-widget>
  </div>
  <div class="flex md12 xs12" style="width: 100%;">
    <vuestic-widget :headerText="$t('report.monthly')">
      <div id="monthChart" ref="monthChart"></div>
    </vuestic-widget>
  </div>

  <div class="flex md12 xs12" v-if="permissions['Download']">
    <vuestic-widget :headerText="$t('report.reportDownload.title')" id="reportInfo">
      <div class="advance-download">
        <router-link :to="{ name: 'AdvanceDownload' }">{{ $t("report.advanceDownload") }}</router-link>
      </div>
      <el-table
        ref="filterTable"
        :data="tableData"
        style="width: 100%"
        :empty-text="$t('tables.dataTable.noDataAvailable')"
      >
        <el-table-column prop="date" :label="$t('report.reportDownload.month')" :width="reportTable.month">
        </el-table-column>
        <el-table-column prop="revenue" :label="$t('report.reportDownload.revenue')" :width="reportTable.revenue" :formatter="revenueFormatter">
        </el-table-column>
        <el-table-column prop="total_trans_count" :label="$t('report.reportDownload.transactions')">
        </el-table-column>
        <el-table-column prop="id" :label="$t('report.reportDownload.actions')" :width="reportTable.actions">
          <template slot-scope="scope">
            <DownloadFileButton
              :download-log-id="scope.row.id"
              api-url="api/dashboard/report/daily-report/temp-url"
              param-name="id"
            />
            <DownloadPasswordButton
              :download-log-id="scope.row.id"
              api-url="api/dashboard/report/daily-report/zip-password"
              param-name="id"
            />
          </template>
        </el-table-column>
      </el-table>
      <div class="block text-center">
        <pagination :total="total" :page.sync="page" :limit.sync="limit" @pagination="drawReportSummary" />
      </div>
    </vuestic-widget>
  </div>

  <!-- Monthly Report -->
  <monthly-report-component />

</div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { request } from '@/utils/utils'
import pageName from '../NewUser/pageNames'
import DownloadFileButton from '@/package/DownloadFileButton.vue'
import DownloadPasswordButton from '@/package/DownloadPasswordButton.vue'
import MonthlyReportComponent from '@/components/Report/MonthlyReportComponent.vue'

export default {
  data () {
    return {
      currency_value: '',
      method_value: '',
      currencyList: [],
      methodList: [],
      tableData: [],
      total: 0, // 数据总条数
      page: 1, // 默认显示第1页
      limit: 6, // 默认一次显示10条数据
      reportTable: {
        month: '180',
        revenue: '180',
        transactions: '',
        actions: '260'
      }
    }
  },
  components: {
    Pagination,
    DownloadFileButton,
    DownloadPasswordButton,
    MonthlyReportComponent
  },
  // 增加详情页面
  computed: {
    isMobile: function () {
      if (document.body.clientWidth && document.body.clientWidth < 750) {
        return 'mobile'
      }
      return 'pc'
    },
    permissions () {
      if (Object.prototype.toString.call(this.$store.getters.user.permissions) === '[object Object]') {
        let storePerm = { ...this.$store.getters.user.permissions }
        const perms = {
          // [pageName.transactions]: false,
          [pageName.report]: false,
          [pageName.appManagement]: false,
          [pageName.finance]: false,
          [pageName.merchantKyc]: false,
          [pageName.userManagement]: false,
          [pageName.wayBill]: false,
          [pageName.recurring]: false,
          [pageName.virtualAccount]: false,
          [pageName.download]: false
        }
        for (let item in storePerm) {
          if (perms[item] !== undefined) {
            perms[item] = !!storePerm[item]
          }
        }
        return perms
      }
      return {}
    }
  },
  async mounted () {
    if (this.isMobile === 'mobile') {
      this.$set(this.reportTable, 'month', 60)
      this.$set(this.reportTable, 'revenue', 80)
      this.$set(this.reportTable, 'transactions', 240)
      this.$set(this.reportTable, 'actions', 220)
    }
    await this.selecting()
    // 调用绘制图表的方法
    this.drawReports()
    this.drawReportSummary()
  },
  methods: {
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    revenueFormatter (row, column) {
      return row.currency + ' ' + row.revenue
    },
    async selecting () {
      let token = localStorage.getItem('Authorization')
      let uid = localStorage.getItem('uid')
      let url = 'api/dashboard/basic/getDropdown?access_token=' + token
      let res = await request({
        method: 'post',
        url,
        '': {}
      })
      this.currencyList = res.data.order_currency
      this.methodList = res.data.method
      this.currency_value = this.currencyList[0]
    },
    drawReports () {
      let token = localStorage.getItem('Authorization')
      let currency = this.currency_value
      let method = this.method_value
      let urls = 'api/dashboard/report/getReportTrend?currency=' + currency + '&method=' + method + '&access_token=' + token + ''

      request({
        method: 'post',
        url: urls
      }).then(res => {
        this.drawDailyReport(res.data.daily)
        this.drawMonthReport(res.data.monthly)
      })
    },
    drawReportSummary () {
      let token = localStorage.getItem('Authorization')
      let start = this.page
      let limit = this.limit
      let urls = 'api/dashboard/report/getReportSummary?pageNum=' + start + '&pageSize=' + limit + '&access_token=' + token

      request({
        method: 'post',
        url: urls
      }).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
      })
    },
    drawDailyReport (dailyData) {
      this.daylist = dailyData
      let dateCon = []
      let successAmount = []
      let refundAmount = []
      let chargebackAmount = []
      let chargebackReversedAmount = []
      for (var i = 0; i < this.daylist.length; i++) {
        dateCon.push(this.daylist[i].date)
        successAmount.push(this.daylist[i].success)
        refundAmount.push(this.daylist[i].refund)
        chargebackAmount.push(this.daylist[i].chargeback)
        chargebackReversedAmount.push(this.daylist[i].chargebackReversed)
      }

      // 实例化echarts对象
      let dailyReportChart = this.$echarts.init(this.$refs.dailyReportChart)
      // 绘制条形图
      dailyReportChart.setOption({
        // color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: [this.$t('t.success'), this.$t('t.refund'), this.$t('t.chargeback'), this.$t('t.chargebackReversed')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: dateCon,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          name: this.currency_value
        }],
        series: [{
          name: this.$t('t.success'),
          type: 'line',
          // barWidth: '80%',
          data: successAmount
        },
        {
          name: this.$t('t.refund'),
          type: 'line',
          // barWidth: '80%',
          data: refundAmount
        },
        {
          name: this.$t('t.chargeback'),
          type: 'line',
          // barWidth: '80%',
          data: chargebackAmount
        },
        {
          name: this.$t('t.chargebackReversed'),
          type: 'line',
          // barWidth: '80%',
          data: chargebackReversedAmount
        }
        ]
      })
    },
    drawMonthReport (monthlyData) {
      this.monthlist = monthlyData
      let monthData = []
      let successAmount = []
      let refundAmount = []
      let chargebackAmount = []
      let chargebackReversedAmount = []
      for (var x = 0; x < this.monthlist.length; x++) {
        monthData.push(this.monthlist[x].date)
        successAmount.push(this.monthlist[x].success)
        refundAmount.push(this.monthlist[x].refund)
        chargebackAmount.push(this.monthlist[x].chargeback)
        chargebackReversedAmount.push(this.monthlist[x].chargebackReversed)
      }

      // 实例化echarts对象
      let monthChart = this.$echarts.init(this.$refs.monthChart)
      // 绘制条形图
      monthChart.setOption({
        // color: ['#3398DB'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: [this.$t('t.success'), this.$t('t.refund'), this.$t('t.chargeback'), this.$t('t.chargebackReversed')]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: monthData,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          name: this.currency_value
        }],
        series: [{
          name: this.$t('t.success'),
          type: 'line',
          // barWidth: '80%',
          data: successAmount
        },
        {
          name: this.$t('t.refund'),
          type: 'line',
          // barWidth: '80%',
          data: refundAmount
        },
        {
          name: this.$t('t.chargeback'),
          type: 'line',
          // barWidth: '80%',
          data: chargebackAmount
        },
        {
          name: this.$t('t.chargebackReversed'),
          type: 'line',
          // barWidth: '80%',
          data: chargebackReversedAmount
        }
        ]
      })
    }
  }
}
</script>
<style lang="scss">
@import "./Report.scss";

.btn-micro {
  letter-spacing: 1px;
  .btn-with-icon-content {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    max-width: 160px;
    .fa-refresh {
      width: 20px;
    }
    b {
      font-weight: 400;
    }
  }
}
.re_time {
    display: block;
    width: 120px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    border-bottom: 2px solid $VUE_APP_COLOR4;
}
.el-select {
    display: block;
    position: relative;
}
.select_btn {
    margin-top: 20px;
    width: 90px;
    height: 28px;
    line-height: 27px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    background: $VUE_APP_COLOR4;
}
.select-title {
    color: $VUE_APP_COLOR3;
}
#dailyReportChart {
    width: 100%;
    height: 370px;
    margin: 20px auto;
}
#monthChart {
    width: 100%;
    height: 370px;
    margin: 20px auto;
}
.table td,
.table th,
.table thead td,
.table thead th {
    text-align: center;
}
#reportInfo.vuestic-widget{
  position: relative;
  .advance-download {
    position: absolute;
    top: 15px;
    right: 30px;
}
}

@media only screen and (max-width: 750px) {
  #reportInfo.vuestic-widget .vuestic-widget-body {
    padding: 0.2rem;
  }
}

</style>
